import { Skeleton } from "@/components/ui/skeleton";

export const LoadingList = ({ rows = 4, testId = "loading-list" }) => (
  <div className="space-y-2" data-testid={testId} aria-busy="true" aria-live="polite">
    {Array.from({ length: rows }).map((_, i) => (
      <div key={i} className="rounded-lg border border-border bg-card px-4 py-3">
        <div className="flex items-start justify-between gap-3">
          <div className="flex-1">
            <Skeleton className="h-3 w-20" />
            <Skeleton className="mt-2.5 h-4 w-2/3" />
            <Skeleton className="mt-2 h-3 w-1/2" />
          </div>
          <Skeleton className="h-5 w-14 rounded-md" />
        </div>
      </div>
    ))}
  </div>
);
